"use client";
import { AppShell, PageLoader } from "../components/app-shell";
import { ProductGrid } from "../components/product-card";
import { EmptyState } from "../components/states";
import { useFavorites } from "../lib/hooks";
import { useI18n } from "../lib/i18n";

export function FavoritesPage() { const { t } = useI18n(); const favorites = useFavorites(); return <AppShell showSearch><main className="standard-page"><div className="page-title"><span className="eyebrow">Мыльница</span><h1>{t("favorites")}</h1></div>{favorites.isLoading ? <PageLoader /> : favorites.products.length ? <ProductGrid products={favorites.products} /> : <EmptyState title={t("favoritesEmpty")} action={t("goCatalog")} />}</main></AppShell>; }
